import React, { createContext, useContext } from 'react';

interface DrawerContextValue {
    close: () => void;
}

const DrawerContext = createContext<DrawerContextValue | null>(null);

export const useDrawerContext = () => {
    const context = useContext(DrawerContext);
    if (!context) {
        throw new Error('useDrawerContext must be used within a Drawer');
    }
    return context;
};

export const DrawerProvider: React.FC<{
    value: DrawerContextValue;
    children: React.ReactNode;
}> = ({ value, children }) => <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>;
